import type { AIMessageDraft } from 'bundles/enterprise-admin-messaging-v2/components/AIMessageModal/types';

/**
 * Stand-in for the real "generate message" backend call. Synthesises an
 * audience summary, subject, and body from the prompt so the Review screen
 * has realistic content to show. Replace the entire function with the real
 * GraphQL mutation once the backend ships.
 */
export const mockGenerateDraft = (
  prompt: string
): Pick<AIMessageDraft, 'audienceSummary' | 'audienceCount' | 'subject' | 'message' | 'ctaText' | 'ctaUrl'> => {
  const trimmedPrompt = prompt.trim();
  return {
    audienceSummary: '150 inactive learners in the last 7 days',
    audienceCount: 150,
    subject: 'We miss you, your courses are waiting',
    message:
      `Hi {Learner},\n\n` +
      `We've noticed you haven't been active in your Coursera learning program recently and we'd love to see you back. Your courses are still waiting for you. Even 15 minutes a day can make a real difference toward your goals.\n\n` +
      `• Continue your learning journey.\n\n` +
      `We're rooting for you!\n` +
      `Your Organization` +
      (trimmedPrompt ? `\n\n— generated from prompt: "${trimmedPrompt}"` : ''),
    ctaText: 'Resume learning',
    ctaUrl: 'https://coursera.org/programs/example',
  };
};
